(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('online-mall-recently-viewed')) {
    class OnlineMallRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.storageKey = 'online-mall:recently-viewed-products';
        this.currentHandle = this.dataset.productHandle || '';
        this.rootUrl = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
        this.limit = Number.parseInt(this.dataset.limit || '8', 10);
        this.storageLimit = Number.parseInt(this.dataset.storageLimit || '24', 10);
        this.renderSection();
      }

      readHandles() {
        try {
          const value = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
          return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
        } catch (error) {
          return [];
        }
      }

      saveCurrent(handles) {
        if (!this.currentHandle) return handles;
        const updated = [this.currentHandle, ...handles.filter((handle) => handle !== this.currentHandle)].slice(0, this.storageLimit);
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(updated));
        } catch (error) {
          return updated;
        }
        return updated;
      }

      async renderSection() {
        const savedHandles = this.readHandles();
        const handlesToShow = savedHandles.filter((handle) => handle !== this.currentHandle).slice(0, this.limit);
        this.saveCurrent(savedHandles);

        if (!handlesToShow.length) {
          this.showEmptyState();
          return;
        }

        const products = await Promise.all(
          handlesToShow.map(async (handle) => {
            try {
              const response = await fetch(`${this.rootUrl}products/${encodeURIComponent(handle)}.js`, {
                headers: { Accept: 'application/json' }
              });
              return response.ok ? response.json() : null;
            } catch (error) {
              return null;
            }
          })
        );

        const validProducts = products.filter(Boolean);
        if (!validProducts.length) {
          this.showEmptyState();
          return;
        }

        const grid = this.querySelector('.recently-viewed__grid');
        const empty = this.querySelector('.recently-viewed__empty');
        empty.hidden = true;
        validProducts.forEach((product) => grid.append(this.createCard(product)));
        this.hidden = false;
      }

      showEmptyState() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        const empty = this.querySelector('.recently-viewed__empty');
        empty.textContent = this.dataset.emptyLabel;
        empty.hidden = false;
        this.hidden = false;
      }

      createCard(product) {
        const article = document.createElement('article');
        article.className = 'recently-viewed__card';
        article.setAttribute('role', 'listitem');

        const productUrl = `${this.rootUrl}products/${encodeURIComponent(product.handle)}`;
        const imageLink = document.createElement('a');
        imageLink.className = 'recently-viewed__image-link';
        imageLink.href = productUrl;
        imageLink.setAttribute('aria-label', product.title);

        if (product.featured_image) {
          const image = document.createElement('img');
          image.className = 'recently-viewed__image';
          image.src = this.resizeImage(product.featured_image);
          image.alt = product.title;
          image.loading = 'lazy';
          image.width = 600;
          image.height = 600;
          imageLink.append(image);
        }

        const content = document.createElement('div');
        content.className = 'recently-viewed__content';

        const title = document.createElement('h3');
        title.className = 'recently-viewed__title';
        const titleLink = document.createElement('a');
        titleLink.className = 'recently-viewed__title-link';
        titleLink.href = productUrl;
        titleLink.textContent = product.title;
        title.append(titleLink);
        content.append(title);

        if (this.dataset.showPrice === 'true') {
          content.append(this.createPrice(product));
        }

        if (this.dataset.showButton === 'true') {
          content.append(this.createForm(product));
        }

        article.append(imageLink, content);
        return article;
      }

      createPrice(product) {
        const price = document.createElement('p');
        price.className = 'recently-viewed__price';

        const current = document.createElement('span');
        current.textContent = this.formatMoney(product.price);
        price.append(current);

        if (product.compare_at_price && product.compare_at_price > product.price) {
          const compare = document.createElement('span');
          compare.className = 'recently-viewed__compare-price';
          compare.textContent = this.formatMoney(product.compare_at_price);
          price.append(compare);
        }

        return price;
      }

      createForm(product) {
        const form = document.createElement('form');
        form.className = 'recently-viewed__form';
        form.method = 'post';
        form.action = this.dataset.cartAddUrl;

        const variant = Array.isArray(product.variants)
          ? product.variants.find((item) => item.available) || product.variants[0]
          : null;

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        input.value = variant ? variant.id : '';

        const button = document.createElement('button');
        button.className = 'recently-viewed__button';
        button.type = 'submit';
        button.disabled = !product.available || !variant;
        button.textContent = button.disabled ? this.dataset.soldOutLabel : this.dataset.buttonLabel;

        form.append(input, button);
        return form;
      }

      resizeImage(source) {
        try {
          const url = new URL(source, window.location.origin);
          url.searchParams.set('width', '600');
          return url.toString();
        } catch (error) {
          return source;
        }
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'bg-BG', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR'
          }).format(amount);
        } catch (error) {
          return `${amount.toFixed(2)} ${this.dataset.currency || 'EUR'}`;
        }
      }
    }

    customElements.define('online-mall-recently-viewed', OnlineMallRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();
})();
